<style lang="scss" scoped>
.filter {
}
.header-container {
  display: flex;

  .col {
    align-content: center;
  }
}

.menu {
}

.filter-table {
  .label {
    max-width: 170px;
    color: rgb(145, 145, 145);
  }
}

.danger {
  color: red !important;
}

.status-chip {
  // width: 100px;
  // justify-content: center;
}
</style>
<template>
  <container class="unities">
    <v-row class="header-container">
      <v-col cols="12" md="4" lg="3">
        <v-text-field
          v-model="filter"
          @keyup.enter="getUnities()"
          :label="$capitalize($tc('model.unities_unit_search'))"
          prepend-inner-icon="mdi-magnify"
          outlined
          class="filter"
          background-color="#fff"
        >
          <template v-slot:append></template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn @click="getUnities()" icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-menu
          offset-x
          v-model="advanced_filter"
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge :value="advanced_filtered" color="red" dot overlap>
              <v-btn v-bind="attrs" v-on="on" icon small>
                <v-icon v-if="!advanced_filter">mdi-filter-menu-outline</v-icon>
                <v-icon v-else>mdi-filter-minus-outline</v-icon>
              </v-btn>
            </v-badge>
          </template>
          <v-form @submit.prevent="handleAdvanceFilter()">
            <v-card flat class="menu">
              <v-card-title>{{
                $capitalize($tc("model.unities_advanced_filters"))
              }}</v-card-title>
              <v-card-text>
                <v-simple-table class="filter-table">
                  <tr>
                    <td class="label">
                      {{ $capitalize($tc("model.unities_name")) }}
                    </td>
                    <td>
                      <v-text-field
                        v-model="advanced_filters.name"
                        clearable
                        dense
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="label">
                      {{ $capitalize($tc("model.unities_email")) }}
                    </td>
                    <td>
                      <v-text-field
                        v-model="advanced_filters.email"
                        clearable
                        dense
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="label">
                      {{ $capitalize($tc("model.unities_schedules")) }}
                    </td>
                    <td>
                      <v-row>
                        <v-col cols="4">
                          <v-select
                            v-model="advanced_filters.scheduling_qty_operator"
                            :items="[
                              {
                                text: $capitalize(
                                  $tc('model.unities_more_than')
                                ),
                                value: '>',
                              },
                              {
                                text: $capitalize(
                                  $tc('model.unities_less_than')
                                ),
                                value: '<',
                              },
                              {
                                text: $capitalize(
                                  $tc('model.unities_equal_to')
                                ),
                                value: '=',
                              },
                            ]"
                            dense
                          ></v-select>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="advanced_filters.scheduling_qty"
                            clearable
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                  <tr>
                    <td class="label">
                      {{ $capitalize($tc("model.unities_rating")) }}
                    </td>
                    <td>
                      <v-row>
                        <v-checkbox
                          v-model="advanced_filters.admin_rating"
                          :value="1"
                          class="mx-2"
                          :label="$capitalize($tc('model.unities_illuminated'))"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="advanced_filters.admin_rating"
                          :value="-1"
                          class="mx-2"
                          :label="$capitalize($tc('model.unities_deleted'))"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="advanced_filters.admin_rating"
                          :value="0"
                          class="mx-2"
                          :label="$capitalize($tc('model.unities_no_votes'))"
                        ></v-checkbox>
                      </v-row>
                    </td>
                  </tr>
                  <tr>
                    <td class="label">
                      {{ $capitalize($tc("model.unities_services")) }}
                    </td>
                    <td>
                      <v-row>
                        <v-select
                          v-model="advanced_filters.service_types"
                          :items="service_types"
                          multiple
                          chips
                          deletable-chips
                          item-text="description"
                          item-value="id"
                          dense
                        >
                          <template v-slot:append-outer>
                            <v-btn @click="loadTypes()" icon>
                              <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                          </template>
                        </v-select>
                      </v-row>
                    </td>
                  </tr>
                  <tr>
                    <td class="label">
                      {{ $capitalize($tc("model.unities_status")) }}
                    </td>
                    <td>
                      <v-row>
                        <v-checkbox
                          v-model="advanced_filters.is_active"
                          :value="true"
                          class="mx-2"
                          :label="$capitalize($tc('model.unities_active'))"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="advanced_filters.is_active"
                          :value="false"
                          class="mx-2"
                          :label="$capitalize($tc('model.unities_blocked'))"
                        ></v-checkbox>
                      </v-row>
                    </td>
                  </tr>
                </v-simple-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="handleResetFilter" text>{{
                  $capitalize($tc("model.unities_clean_button"))
                }}</v-btn>
                <v-btn type="submit" color="primary">{{
                  $capitalize($tc("model.unities_search_button"))
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-menu>
      </v-col>
      <v-col class="text-right">
        <ScopeProvider scope="unities.add">
          <v-btn @click="handleOpenDialog()" color="primary">
            <v-icon left>mdi-plus</v-icon
            >{{ $capitalize($tc("model.unities_new_unit_button")) }}
          </v-btn>
        </ScopeProvider>
      </v-col>
    </v-row>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="5"
        :disabled="loading"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :loading-text="$capitalize($tc('model.unities_loading'))"
        fixed-header
        max-height="500px"
      >
        <template v-slot:header.name>
          {{ $capitalize($tc("model.contact_name", 1)) }}
        </template>

        <template v-slot:header.email>
          {{ $capitalize($tc("model.unities_email", 1)) }}
        </template>

        <template v-slot:header.service_types>
          {{ $capitalize($tc("model.unities_services", 1)) }}
        </template>

        <template v-slot:header.scheduling_qty>
          {{ $capitalize($tc("model.unities_schedules", 1)) }}
        </template>

        <template v-slot:header.actuation_zones_qty>
          {{ $capitalize($tc("model.unities_performance_zones", 1)) }}
        </template>

        <template v-slot:header.team_name>
          {{ $capitalize($tc("model.unities_team_table_column", 1)) }}
        </template>

        <template v-slot:header.status>
          {{ $capitalize($tc("model.unities_status", 1)) }}
        </template>

        <template v-slot:item.name="{ item }">
          <div>
            {{ item.name }}
            <v-tooltip top v-if="item.admin_rating == 1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="blue" v-bind="attrs" v-on="on" small
                  >mdi-check-decagram</v-icon
                >
              </template>
              <span>{{
                $capitalize($tc("model.unities_good_performance"))
              }}</span>
            </v-tooltip>
            <v-tooltip top v-else-if="item.admin_rating == -1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="red lighten-1" v-bind="attrs" v-on="on" small
                  >mdi-alert-decagram</v-icon
                >
              </template>
              <span>{{
                $capitalize($tc("model.unities_poor_performance"))
              }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.team_name="{ item }">
          <v-chip
            v-if="item.team_id"
            :to="`/teams/${item.team_id}`"
            small
            color="indigo"
            dark
            label
          >
            {{ item.team_name }}
          </v-chip>
          <span v-else class="grey--text">Nenhum</span>
        </template>
        <template v-slot:item.service_types="{ item }">
          <div>
            <v-chip
              v-for="service_type in item.service_types"
              :key="service_type.id"
              class="mr-1 my-1"
              small
              >{{ service_type.description }}</v-chip
            >
            <span class="grey--text" v-if="item.service_types.length === 0">{{
              $capitalize($tc("model.unities_none"))
            }}</span>
          </div>
        </template>
        <template v-slot:item.is_user_active="{ item }">
          <v-chip
            v-if="item.is_user_active"
            class="status-chip"
            dark
            label
            small
            color="green darken-1"
            >{{ $capitalize($tc("model.unities_active")) }}</v-chip
          >
          <v-chip v-else small class="status-chip" dark label color="red">{{
            $capitalize($tc("model.unities_blocked"))
          }}</v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div>
            <v-menu offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-on="on" v-bind="attrs">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="handleEditUser(item, true)">
                  <v-icon left size="20">mdi-eye</v-icon>
                  <v-list-item-title>{{
                    $capitalize($tc("model.unities_see_unit"))
                  }}</v-list-item-title>
                </v-list-item>
                <ScopeProvider scope="unities.edit">
                  <v-list-item @click="handleEditUser(item)">
                    <v-icon left size="20">mdi-pencil</v-icon>
                    <v-list-item-title>{{
                      $capitalize($tc("model.unities_alter_unit"))
                    }}</v-list-item-title>
                  </v-list-item>
                </ScopeProvider>
                <ScopeProvider scope="unities.hate">
                  <v-list-item
                    v-if="item.admin_rating == 0"
                    @click="setRating(item, 1)"
                  >
                    <v-icon left size="20">mdi-check-decagram</v-icon>
                    <v-list-item-title>{{
                      $capitalize($tc("model.unities_illuminate"))
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="item.admin_rating == 0"
                    @click="setRating(item, -1)"
                  >
                    <v-icon left size="20">mdi-alert-decagram</v-icon>
                    <v-list-item-title>{{
                      $capitalize($tc("model.unities_eliminate"))
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-else-if="item.admin_rating !== 0"
                    @click="setRating(item, 0)"
                  >
                    <v-icon left size="20">mdi-eraser</v-icon>
                    <v-list-item-title>{{
                      $capitalize($tc("model.unities_remove_rating"))
                    }}</v-list-item-title>
                  </v-list-item>
                </ScopeProvider>
                <v-divider></v-divider>
                <ScopeProvider scope="auth.users.edit_status">
                  <v-list-item
                    @click="changeUserActive(item)"
                    v-if="item.is_user_active"
                    :disabled="checkSelfDestruction(item.user_id)"
                  >
                    <v-icon color="red" left size="20">mdi-lock</v-icon>
                    <v-list-item-title class="red--text">{{
                      $capitalize($tc("model.unities_block"))
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="changeUserActive(item)" v-else>
                    <v-icon left size="20" color="red">mdi-lock-open</v-icon>
                    <v-list-item-title class="red--text">{{
                      $capitalize($tc("model.unities_unlock"))
                    }}</v-list-item-title>
                  </v-list-item>
                </ScopeProvider>
                <ScopeProvider scope="unities.delete">
                  <v-list-item value="true" @click="handleRemoveUnity(item)">
                    <v-icon color="red" left size="20">mdi-delete</v-icon>
                    <v-list-item-title class="red--text">{{
                      $capitalize($tc("model.unities_remove"))
                    }}</v-list-item-title>
                  </v-list-item>
                </ScopeProvider>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="unity_dialog" max-width="500" persistent>
      <unity-form
        v-model="unity"
        :title="$capitalize($tc('model.unities_unit_data'))"
        :readonly="readonly"
        @submit="handleSubmitForm"
        @close="handleCloseDialog"
      ></unity-form>
    </v-dialog>

    <v-dialog v-model="confirm_dialog" max-width="300" persistent>
      <v-card>
        <v-card-title>
          {{ $capitalize($tc("model.unities_unit_remove")) }}
          <v-spacer></v-spacer>
          <v-btn @click="confirm_dialog = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loading_deleting_unity"
            text
            @click="confirm_dialog = false"
            >{{ $capitalize($tc("model.unities_no")) }}</v-btn
          >
          <v-btn
            :loading="loading_deleting_unity"
            color="red"
            dark
            @click="removeUnity()"
            >{{ $capitalize($tc("model.unities_remove")) }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<script>
import { mapActions } from "vuex";
import UnityForm from "../components/forms/UnityForm";
import {
  index as indexUnities,
  show as showUnity,
  update as updateUnity,
  destroy as deleteUnity,
} from "../services/unities";
import { update as updateUser, updateStatus } from "../services/users";
import { groupBy } from "../tools/array";
import ScopeProvider from "@/components/ScopeProvider";

export default {
  name: "unities",
  components: { UnityForm, ScopeProvider },
  data: () => ({
    items: [],
    headers: [
      { text: "Nome", value: "name" },
      { text: "Email", value: "email" },
      { text: "Serviços", value: "service_types", width: 300, sortable: false },
      { text: "Agendamentos", value: "scheduling_qty", align: "center" },
      {
        text: "Zonas de Atuação",
        value: "actuation_zones_qty",
        align: "center",
      },
      { text: "", value: "rating", align: "center" },
      { text: "Equipe", value: "team_name" },
      { text: "Status", value: "is_user_active", align: "center", width: 100 },
      { text: "", value: "actions", align: "right", sortable: false },
    ],
    loading: false,
    totalItems: 0,
    options: {
      itemsPerPage: 10,
      sortBy: ["name"],
      sortDesc: [],
    },
    unity_dialog: false,
    filter: "",
    advanced_filter: false,
    advanced_filters: {
      admin_rating: [],
      is_active: [],
      scheduling_qty_operator: ">",
      service_types: [],
    },
    advanced_filtered: false,
    unity: {},
    confirm_dialog: false,
    confirm_unity: null,
    loading_deleting_unity: false,
    readonly: false,
  }),
  methods: {
    async handleEditUser(unity, readonly = false) {
      this.loading = true;
      try {
        const unityRecord = await showUnity({}, unity.id);

        this.unity = {
          id: unity.id,
          user: unity.user_id,
          user_name: unity.name,
          team_id: unity.team_id,
          service_types: unity.service_types.map(
            (service_type) => service_type.id
          ),
          actuation_zones: groupBy(
            unityRecord.actuation_zones,
            (zone) => zone.country_area_id
          ).map(([country_area_id, zones]) => ({
            id: country_area_id,
            cities: zones.map((city) => city.id),
          })),
        };
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao carregar utilizador",
          color: "red",
        });
      } finally {
        this.loading = false;
        this.unity_dialog = true;
        this.readonly = readonly;
      }
    },
    handleResetFilter() {
      this.advanced_filters = {
        admin_rating: [],
        is_active: [],
        scheduling_qty_operator: ">",
        service_types: [],
      };
      this.advanced_filter = false;
      this.getUnities();
    },
    toggleAdvancedFilter() {
      this.advanced_filter = !this.advanced_filter;
    },
    checkSelfDestruction(item_user_id) {
      return this.user.sub == item_user_id;
    },
    handleSubmitForm(event) {
      this.getUnities();
    },
    handleOpenDialog() {
      this.unity_dialog = true;
      this.readonly = false;
    },
    handleCloseDialog() {
      this.unity_dialog = false;
    },
    handleAdvanceFilter() {
      this.getUnities();
      this.advanced_filter = false;
    },
    checkAdvancedFilterInParams(params) {
      return (
        !!params.name ||
        !!params.email ||
        params.admin_rating.length ||
        params.is_active.length ||
        !isNaN(params.scheduling_qty) ||
        this.advanced_filters.service_types.length
      );
    },
    async getUnities() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.loading = true;
      this.items = [];

      try {
        const params = {
          paginate: true,
          orderBy: sortBy[0] ? sortBy[0] : "",
          sortDesc: sortDesc[0] ? sortBy[0] : "",
          page,
          perPage: itemsPerPage,
          filter: this.filter || "",
          name: this.advanced_filters.name,
          email: this.advanced_filters.email,
          admin_rating: this.advanced_filters.admin_rating,
          is_active: this.advanced_filters.is_active,
          scheduling_qty_operator: this.advanced_filters
            .scheduling_qty_operator,
          scheduling_qty: parseInt(this.advanced_filters.scheduling_qty),
          service_types: this.advanced_filters.service_types,
        };

        const data = await indexUnities(params);

        this.items = data.data;
        this.totalItems = data.total;
        this.advanced_filtered = this.checkAdvancedFilterInParams(params);
      } catch (error) {
        this.items = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    },
    toggleLike(unity) {
      this.items.map((item) => {
        if (item.id === unity.id) {
          item.admin_rating = item.admin_rating == 1 ? 0 : 1;
        }

        return unity;
      });
    },
    toggleUnlike(unity) {
      this.items.map((item) => {
        if (item.id === unity.id) {
          item.admin_rating = item.admin_rating == -1 ? 0 : -1;
        }

        return unity;
      });
    },

    async setRating(unity, rating) {
      this.items.map((item) => {
        if (item.id === unity.id) {
          item.admin_rating = rating;
        }

        return unity;
      });

      try {
        await updateUnity(
          {
            admin_rating: rating,
          },
          unity.id
        );
      } catch (error) {
        this.items.map((item) => {
          if (item.id === unity.id) {
            item.admin_rating = unity.admin_rating;
          }

          return unity;
        });
      }
    },
    async changeUserActive(unity) {
      const status = !unity.is_user_active;

      //Feedback instantâneo
      this.items.map((item) => {
        if (item.id === unity.id) {
          item.is_user_active = status;
        }

        return unity;
      });

      try {
        await updateStatus(unity.user_id, status);
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível mudar status do utilizador",
          color: "red",
        });
        //Retorna o estado anterior
        this.items.map((item) => {
          if (item.id === unity.id) {
            item.is_user_active = !status;
          }

          return unity;
        });
      }
    },
    handleRemoveUnity(unity) {
      this.confirm_dialog = true;
      this.confirm_unity = unity;
    },
    async removeUnity() {
      this.loading_deleting_unity = true;
      try {
        await deleteUnity(this.confirm_unity.id);
        this.items = this.items.filter(
          (item) => item.id !== this.confirm_unity.id
        );
        this.$store.commit("sendMessage", {
          text: "Unidade excluída com sucesso",
        });
        this.confirm_dialog = false;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível excluír a unidade",
          color: "red",
        });
      } finally {
        this.loading_deleting_unity = false;
      }
    },
    ...mapActions("lead_types", ["loadTypes"]),
  },
  computed: {
    user() {
      return this.$store.getters["auth/getUser"];
    },
    service_types() {
      return this.$store.getters["lead_types/getLeadTypes"];
    },
  },
  watch: {
    options: {
      handler() {
        this.getUnities();
      },
      deep: true,
    },
    filter: function (value) {
      if (value == null) this.getUnities();
    },
  },
  created() {
    this.getUnities();
    this.loadTypes();
  },
};
</script>
